import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    loadNews(currentPage);
  }, [currentPage]);

  const loadNews = async (page) => {
    try {
      const response = await api.get('/news/', { params: { page } });
      setNews(response.data.results);
      setTotalPages(Math.ceil(response.data.count / 10));
    } catch (error) {
      console.error('Error loading news:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-5">News & Updates</h1>
      <Row>
        {news.map(item => (
          <Col key={item.id} md={6} lg={4} className="mb-4">
            <Card className="h-100">
              {item.featured_image && (
                <Card.Img 
                  variant="top" 
                  src={getMediaUrl(item.featured_image)} 
                  alt={item.title}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
              )}
              <Card.Body>
                <Card.Title>
                  <Link to={`/news/${item.slug}`}>{item.title}</Link>
                </Card.Title>
                <Card.Text className="text-muted small">
                  {moment(item.published_date).format('MMMM DD, YYYY')}
                </Card.Text>
                <Card.Text>
                  {item.summary || item.content.replace(/<[^>]*>/g, '').substring(0, 150)}...
                </Card.Text>
                <Link to={`/news/${item.slug}`} className="btn btn-primary btn-sm">
                  Read More
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      
      {totalPages > 1 && (
        <Pagination className="justify-content-center mt-4">
          <Pagination.Prev 
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={currentPage === i + 1}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next 
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      )}
    </Container>
  );
};

export default News;
